import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

const alertVariants = cva("app-alert", {
  variants: {
    tone: {
      default: "app-alert--default",
      danger: "app-alert--danger",
      success: "app-alert--success",
      warning: "app-alert--warning",
    },
  },
  defaultVariants: { tone: "default" },
});

export function Alert({
  className,
  tone,
  ...props
}: HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>) {
  return <div className={cn(alertVariants({ tone }), className)} {...props} />;
}
